export default "__VITE_ASSET__BdzX7HWK__"